module.exports = __webpack_public_path__ + "static/media/visit_list.124e5adb.svg";